module.exports = __webpack_public_path__ + "static/build_proto-6321d89f4ec30632b9919d5313c2e418.svg";